/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetUsersUseridReplayMetricsQueryResponse,
  GetUsersUseridReplayMetricsPathParams,
} from "../types/GetUsersUseridReplayMetrics.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getUsersUseridReplayMetricsQueryKey = (
  userId: GetUsersUseridReplayMetricsPathParams["userId"] | undefined,
) =>
  [
    { url: "/users/:userId/replay-metrics", params: { userId: userId } },
  ] as const;

export type GetUsersUseridReplayMetricsQueryKey = ReturnType<
  typeof getUsersUseridReplayMetricsQueryKey
>;

/**
 * @summary Метрики игрока за всё время — для профиля.
 * Нет ни одной разобранной игры — `200` с телом `null`, а НЕ `404` (KAN-1055): это
 * штатное состояние, а превью профиля открывают пачками, и каждое давало красную
 * строку в консоли прода. `null`, а не нули: «не играл» и «сыграл и ничего не делал»
 * — разные факты.
 * Перцентилей в ответе нет: они считаются внутри турнира, а тут турниров много.
 * {@link /users/:userId/replay-metrics}
 */
export async function getUsersUseridReplayMetrics(
  userId: GetUsersUseridReplayMetricsPathParams["userId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetUsersUseridReplayMetricsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/users/${userId}/replay-metrics`,
    ...requestConfig,
  });
  return res;
}

export function getUsersUseridReplayMetricsQueryOptions(
  userId: GetUsersUseridReplayMetricsPathParams["userId"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getUsersUseridReplayMetricsQueryKey(userId);
  return queryOptions<
    ResponseConfig<GetUsersUseridReplayMetricsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetUsersUseridReplayMetricsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!userId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getUsersUseridReplayMetrics(userId!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary Метрики игрока за всё время — для профиля.
 * Нет ни одной разобранной игры — `200` с телом `null`, а НЕ `404` (KAN-1055): это
 * штатное состояние, а превью профиля открывают пачками, и каждое давало красную
 * строку в консоли прода. `null`, а не нули: «не играл» и «сыграл и ничего не делал»
 * — разные факты.
 * Перцентилей в ответе нет: они считаются внутри турнира, а тут турниров много.
 * {@link /users/:userId/replay-metrics}
 */
export function useGetUsersUseridReplayMetrics<
  TData = ResponseConfig<GetUsersUseridReplayMetricsQueryResponse>,
  TQueryData = ResponseConfig<GetUsersUseridReplayMetricsQueryResponse>,
  TQueryKey extends QueryKey = GetUsersUseridReplayMetricsQueryKey,
>(
  userId: GetUsersUseridReplayMetricsPathParams["userId"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetUsersUseridReplayMetricsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getUsersUseridReplayMetricsQueryKey(userId);

  const query = useQuery(
    {
      ...getUsersUseridReplayMetricsQueryOptions(userId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
